import { render, staticRenderFns } from "./CreateSupplierOrderView.vue?vue&type=template&id=20555edf&scoped=true&"
import script from "./CreateSupplierOrderView.vue?vue&type=script&lang=ts&"
export * from "./CreateSupplierOrderView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20555edf",
  null
  
)

export default component.exports